import Loyalty from './Loyalty'

export default Loyalty
